"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withTheme = _interopRequireDefault(require("./withTheme"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = (0, _withTheme.default)(() => /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
    fill: "currentColor",
    x: "3.23",
    y: "4.71",
    width: "2.16",
    height: "11.6"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
    fill: "currentColor",
    x: "7.28",
    y: "9.35",
    width: "2.16",
    height: "6.96"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
    fill: "currentColor",
    x: "11.33",
    y: "8.19",
    width: "2.16",
    height: "8.12"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
    fill: "currentColor",
    x: "15.38",
    y: "11.57",
    width: "2.16",
    height: "4.74"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "currentColor",
    d: "M22.49,4H20.77V2.34A1.51,1.51,0,0,0,19.26.83H1.51A1.52,1.52,0,0,0,0,2.34V18.46A1.52,1.52,0,0,0,1.51,20H3.23v1.69a1.51,1.51,0,0,0,1.51,1.51H22.49A1.52,1.52,0,0,0,24,21.66V5.54A1.52,1.52,0,0,0,22.49,4ZM1.15,18.46V2.34A.36.36,0,0,1,1.51,2H19.26a.36.36,0,0,1,.36.36V18.46a.36.36,0,0,1-.36.36H1.51A.36.36,0,0,1,1.15,18.46Zm21.7,3.2a.36.36,0,0,1-.36.36H4.74a.36.36,0,0,1-.36-.36V20H19.26a1.51,1.51,0,0,0,1.51-1.51V5.18h1.72a.36.36,0,0,1,.36.36Z"
  })]
}));